import router from '../../router/index'
// import AuthRepository from '../../repositories/AuthRepository'
import Repository from '../../repositories/Repository'
// import ms from '../../utils/messeging'
import Store from '../../store'

export default {
  namespaced: true,
  state: {
    token: null,
    gsm: null
  },

  mutations: {
    saveSession: (state, session) => {
      state.token = session.token
      state.gsm = session.gsm
      localStorage.setItem('gsm', session.gsm)
      localStorage.setItem('token', session.token)
      // Store.state.selectedNumber = session.gsm
      // router.push('/home')
      location.reload()
      // router.push(router.currentRoute.path)
      // Repository.defaults.headers.common.Authorization = `Bearer ${state.token}`
    },
    clearSession: (state) => {
      state.gsm = null
      state.token = null
      localStorage.removeItem('gsm')
      localStorage.removeItem('token')
      localStorage.removeItem('selectedNum')
      Store.state.selectedNumber = null
      location.reload()
      router.push('/home')
      // setTimeout(() => {
      //   location.reload()
      // })
      // location.reload()
      // ms.successMessage('Logged out successfully')
      // delete Repository.defaults.headers.common.Authorization
    },
    fetchSession: (state) => {
      state.token = localStorage.getItem('token')
      state.gsm = localStorage.getItem('gsm')
      // Change the value of selected number to previous selected num if founded or to the gsm value
      Store.state.selectedNumber = localStorage.getItem('selectedNum') !== null ? localStorage.getItem('selectedNum') : localStorage.getItem('gsm')
      if (state.token !== null) {
        Repository.defaults.headers.common.Authorization = `Bearer ${state.token}`
      }
    }
  },
  actions: {
    async doLogin ({ commit }, response) {
      commit('saveSession', response)
      // let status = null
      // await AuthRepository.login(userInfo).then(response => {
      //   status = response.logRes.data.status
      //   // console.log('user res', response.logRes.data.status)
      //   if (response.logRes.status === 200) {
      //     // console.log('status', response.data.status)
      //     // console.log('status', data.status)
      //     // console.log('token', response.logRes.data.data.token)
      //     commit('saveSession', response.logRes.data.data)
      //     // console.log('data', response.data.data.token)
      //     router.push('/')
      //   }
      // })
      //   .catch(response =>
      //     console.log(response)
      //   )
      // return {
      //   status: status
      // }
    },
    async doLogout ({ commit }) {
      // try {
      //     await authReposirtory.logout()
      // }
      // finally {
      commit('clearSession')
      router.push('/home')
      // }
    },
    // async checkToken ({ commit, dispatch }) {
    //   let { data } = await AuthRepository.check()
    // },
    localyLogOut ({ commit }) {
      commit('clearSession')
      // router.push('/login')
    }
  }
}
